import styles from '../styles/LoginForm.module.scss';
import logo from '../assets/logo.png';
import entraLogo from '../assets/microsoft-entra-icon.png';
import { useLocalization } from '@progress/kendo-react-intl';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useLoginFormValidator } from '../components/login/customHooks/useLoginFormValidator';
import clsx from 'clsx';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { loadingPanel } from '../components/LoadingPanel';
import { Switch } from '@progress/kendo-react-inputs';
import { AppContext } from '../AppContext';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { locales } from '../resources/locales';
import { emailValidator } from '../components/login/validators';



export const LoginPage = ({ handleLogin = () => { } }) => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const isLocalLoginEnabled = (process.env.REACT_APP_LOCAL ?? 'true').toLowerCase() === 'true';
  const isSsoLoginEnabled = (process.env.REACT_APP_SSO ?? 'true').toLowerCase() === 'true';
  const showLoginModeSwitch = isLocalLoginEnabled && isSsoLoginEnabled;

  const localizationService = useLocalization()
  const navigate = useNavigate()
  let languageId = localStorage.getItem('languageId');

  const { localeId, onLanguageChange } = useContext(AppContext);
  const currentLanguage = locales.find(item => item.localeId === localeId);

  const [loading, setLoading] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [message, setMessage] = useState<any>('');
  const [sentMessage, setSentMessage] = useState<any>('');
  const [imageLogo, setImageLogo] = useState<any>(null);

  const [showForgotPassword, setShowForgotPassword] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string>('');
  const [errorEmail, setErrorEmail] = useState<boolean>(true)

  const [form, setForm] = useState({
    username: "",
    password: "",
    //email: "",
    //confirmPassword: "",
  });

  const { errors, validateForm, onBlurField, getFieldError } = useLoginFormValidator(form);

  const [switchADLogin, setSwitchADLogin] = useState<boolean>(() => {
    if (isSsoLoginEnabled && !isLocalLoginEnabled) {
      return true;
    }
    return false;
  });

  useEffect(() => {
    if (!showLoginModeSwitch) {
      setSwitchADLogin(isSsoLoginEnabled && !isLocalLoginEnabled);
    }
  }, [showLoginModeSwitch, isLocalLoginEnabled, isSsoLoginEnabled]);

  const onUpdateField = (e: any) => {
    const field = e.target.name as keyof typeof errors;
    const nextFormState = {
      ...form,
      [field]: e.target.value,
    };
    setForm(nextFormState);
    if (errors[field].dirty)
      validateForm({
        form: nextFormState,
        errors,
        field,
      });
  };

  const onSubmitForm = async (e: any) => {
    e.preventDefault();
    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    if (!isValid) return;

    setLoading(true)

    // call API 
    const params = {
      username: form.username,
      password: form.password,
    };

    try {
      await axios.post(`${SERVER_URL}/account/login`, params)
        .then(function (response) {

          let userType:any = response?.data?.data?.userType
          let admin:any = response?.data?.data?.admin
          
          localStorage.setItem("accessToken", response?.data?.data?.token);
          localStorage.setItem("username", response?.data?.data?.username);          
          localStorage.setItem("email", response?.data?.data?.email);          
          localStorage.setItem("accountId", response?.data?.data?.id);          
          localStorage.setItem("admin", admin);                    
          localStorage.setItem("userType", userType);     

          if(userType == 'StandardOnlySyncro'){
            navigate('/home/synoptic')
          }else if(response?.data?.data?.username == 'azure'){
              navigate('/home/azure_map')
          }else{
              navigate('/home/dashboard')            
          }
          setLoading(false)
        })
        .catch(function (error) {
          let message = error?.response?.data?.errorMessage ?? error?.response?.statusText
          let code = error?.response?.status
          if (code == 500 && message!.includes('account not enabled')) {
            setVisible(true)
            const userUnauthorized = localizationService.toLanguageString('login_error.account_not_enabled', 'NOT FOUND')
            setMessage(userUnauthorized)
            setTimeout(() => {
              setVisible(false)
            }, 10000)
          } 
          else if (code == 500 && message!.includes('User or password are invalid')) {
            setVisible(true)
            const userUnauthorized = localizationService.toLanguageString('login_error.invalid_credentials', 'NOT FOUND')
            setMessage(userUnauthorized)
            setTimeout(() => {
              setVisible(false)
            }, 10000)
          } 
          else if (message!.includes(`User doesn't have an email`)) {
            const userWithNoEmail = localizationService.toLanguageString('login_error.user_with_no_email', 'NOT FOUND')
            setVisible(true)
            setMessage(userWithNoEmail)
            setTimeout(() => {
              setVisible(false)
            }, 10000)
          }
          setLoading(false)
        });

    } catch (error: any) {
      console.log(error);
      setVisible(false)
    }
  };

  const toggleDialog = () => {
    setVisible(!visible);
  };

  const handleToggleSwitch = () => {
    setSwitchADLogin(!switchADLogin);
    if (showForgotPassword) {
      setShowForgotPassword(false)
    }
  }

  const getImageLogo = async () => {
    axios.get(`${SERVER_URL}/account/logo`)
      .then((res) => {
        const image = `data:image/png;base64, ${res?.data?.data.image}`
        setImageLogo(image);
      }).catch(() => {

      });
  }

  useEffect(() => {
    getImageLogo();
  }, [])

  const onLanguageChangeSystem: any = useCallback((event: any) => {
    localStorage.setItem('languageId', event.value.localeId)
  }, [languageId])

  const sendRecoveryEmail = (userEmail: any) => {
    axios.post(`${SERVER_URL}/account/password/forgot/${userEmail}`)
      .then((res) => {
        const message = localizationService.toLanguageString('login_error.recovery_email_sent', 'NOT FOUND')
        setSentMessage(message)
        setShowForgotPassword(false)
        setUserEmail('')
        if(sentMessage == ''){
          setTimeout(() => {
            setSentMessage('')
          }, 5000)
        }
      }).catch((err) => {
        let code = err?.response?.status
        let message = err?.response?.data?.errorMessage ?? err?.response?.statusText
        setVisible(true)
        if (code == 500 && message!.includes('Account is not local')) {
            setVisible(true)
            const accountNotLocal = localizationService.toLanguageString('login_error.account_not_local', 'NOT FOUND')
            setMessage(accountNotLocal)
            setTimeout(() => {
              setVisible(false)
        }, 3000)}
      });
  }

  const handleEmailChange = (event: any) => {

    const errorMessage: any = emailValidator(event.target.value, localizationService);

    if (errorMessage) {
      setErrorEmail(true)
    } else {
      setErrorEmail(false)
    }

    setUserEmail(event.target.value);

  };

  return (
    <div className={styles.form}>
      {loading && loadingPanel}
      <img src={logo} className={styles.logo} />
      <h1 className={styles.textLocator}>{localizationService.toLanguageString('title', 'NOT FOUND')}</h1>
      <img src={imageLogo} style={{ margin: '10px auto', textAlign: 'center', display: 'block', width: '200px' }} />

      {showForgotPassword && !switchADLogin ?
        <>
          {/*reset password*/}
          <div className={styles.formGroup}>
            <p style={{ color: '#3A8580', fontSize: '0.9rem' }}>
              {localizationService.toLanguageString('login.message', 'NOT FOUND')}
            </p>
            <label className={styles.formLabel}>Email</label>
            <input
              style={{ padding: '0.5rem' }}
              type="text"
              aria-label="Email field"
              name="email"
              value={userEmail}
              onChange={handleEmailChange}
              onBlur={onBlurField}
            />
          </div>

          <div className={styles.formActions}>
            <button
              className={styles.formSubmitBtn}
              disabled={errorEmail}
              onClick={() => sendRecoveryEmail(userEmail)}
            >
              {localizationService.toLanguageString('login.send_email', 'NOT FOUND')}
            </button>
            <button className={styles.backToLogin} onClick={() => setShowForgotPassword(false)}>
              {localizationService.toLanguageString('login.back_to_login', 'NOT FOUND')}
            </button>
          </div>
        </>
        :
        !switchADLogin ?
          <>
            <form onSubmit={onSubmitForm}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Username</label>
                <div className="fieldWithErrorBubble">
                  <input
                    className={clsx(
                      styles.formField,
                      errors.username.dirty && errors.username.error && styles.formFieldError
                    )}
                    type="text"
                    aria-label="Username field"
                    name="username"
                    value={form.username}
                    onChange={onUpdateField}
                    onBlur={onBlurField}
                  />
                  {getFieldError('username') ? (
                    <span className={styles.inputErrorOverlay} role="alert" aria-live="polite">{getFieldError('username')}</span>
                  ) : null}
                </div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Password</label>
                <div className="fieldWithErrorBubble">
                  <input
                    className={clsx(
                      styles.formField,
                      errors.password.dirty &&
                      errors.password.error &&
                      styles.formFieldError
                    )}
                    type="password"
                    aria-label="Password field"
                    name="password"
                    value={form.password}
                    onChange={onUpdateField}
                    onBlur={onBlurField}
                  />
                  {getFieldError('password') ? (
                    <span className={styles.inputErrorOverlay} role="alert" aria-live="polite">
                      {getFieldError('password')}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className={styles.formActions}>
                <button
                  className={styles.formSubmitBtn}
                  disabled={
                    (errors.username.error || errors.password.error) ||
                    (!form.username || !form.password)
                  }
                  type="submit"
                >
                  {localizationService.toLanguageString('login.log_in', 'NOT FOUND')}
                </button>
                <p
                  style={{ color: '#3A8580' }}
                  onClick={() => setShowForgotPassword(true)}
                >
                  {localizationService.toLanguageString('login.forgot_password', 'NOT FOUND')}
                </p>
              </div>
            </form>
          </>
          :
          <div className={styles.entraActions}>
            {/*Entra Login */}
            <img src={entraLogo} width="48" height="48" />
            <a style={{ marginLeft: '20px', fontSize: 'large' }}>Microsoft Entra ID</a>
            <button type={'submit'} onClick={() => handleLogin()} className={styles.signButton}>
              {localizationService.toLanguageString('login.log_in', 'NOT FOUND')}
            </button>
          </div>
      }
      <div style={{ display: 'flex', alignItems: 'baseline', paddingTop: '20px', borderTop: '1px solid #3A8580' }}>
        
        {showLoginModeSwitch && (
          <div style={{ display: 'flex' }}>
            {!switchADLogin ?
              <p style={{ width: '170px', marginTop: '-5px' }}>{localizationService.toLanguageString('login.switch_to_sso', 'NOT FOUND')}:</p>
              :
              <p style={{ width: '170px', marginTop: '-5px' }}>{localizationService.toLanguageString('login.switch_to_static', 'NOT FOUND')}:</p>
            }

            <Switch
              className={'k-switch'}
              onChange={handleToggleSwitch}
              checked={switchADLogin}
            />
          </div>
        )}

        <div className="language-chooser" style={{ display: 'contents' }}>
          <p style={{ margin: '0px 10px 0px 60px' }}>{localizationService.toLanguageString('language', 'NOT FOUND')}:</p>
          <DropDownList
            className="button-language"
            textField={'locale'}
            dataItemKey={'localeId'}
            data={locales}
            value={currentLanguage}
            onChange={(e: any) => {
              onLanguageChange(e);
              onLanguageChangeSystem(e);
            }}
          />
        </div>
      </div>
      <NotificationGroup
        style={{
          right: 0,
          bottom: 0
        }}
      >
        <Fade enter={true} exit={true}>
          {visible && (
            <Notification
              type={{ style: "error", icon: true }}
              closable={true}
              onClose={() => setVisible(false)}
            >
              <span>{message}</span>
            </Notification>
          )}
          {sentMessage != '' && (
            <Notification
              type={{ style: "success", icon: true }}
              closable={true}
              onClose={() => setSentMessage(false)}
            >
              <span>{sentMessage}</span>
            </Notification>
          )}
        </Fade>
      </NotificationGroup>
    </div>
  )
}